(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/selectors/assets/javascripts/create-game.js') >= 0) return;  svs.modules.push('/components/marketplace-data/selectors/assets/javascripts/create-game.js');
"use strict";


const selectCreateGame = state => state.CreateGame;
setGlobal('svs.components.marketplaceData.selectors.createGame', {
  selectCreateGame
});

 })(window);